import { FormItemProps } from '@seiue/ui'
import { InputNumberProps, InputProps, RadioGroupProps } from 'antd'
import { TextAreaProps } from 'antd/es/input'

export enum FormItemType {
  Input = 'input',
  Number = 'number',
  TextArea = 'textArea',
  Radio = 'radio',
}

export interface OptionProps {
  label: string
  value: string
}

export interface ComponentConfig {
  inputProps?: InputProps
  inputNumberProps?: InputNumberProps
  textAreaProps?: TextAreaProps
  radioGroupProps?: RadioGroupProps
}

export interface CustomizeFormItemProps {
  type: FormItemType
  formItemConfig: FormItemProps
  componentConfig?: ComponentConfig
  hidden?: boolean
}
